import { Box, Flex } from '@chakra-ui/react'
import { useColorMode } from 'uikit/ColorMode/ColorMode'
import { GoQuestion } from 'react-icons/go'

export const ItemIcon = ({
  IconComponent = GoQuestion,
  badge,
  color = 'gray.400',
  size = '18px',
  ...props
}) => {
  const { colorMode } = useColorMode()
  const themeBgContainer = colorMode === 'light' ? 'gray.200' : 'gray.700'
  const themeBgContainerHover = colorMode === 'light' ? 'gray.200' : 'gray.600'
  return (
    <Flex
      align="center"
      justify="center"
      zIndex={2}
      transition="0.3s"
      position="relative"
      _groupHover={
        {
          //backgroundColor: themeBgHover
        }
      }
      {...props}
    >
      <Box
        minW="36px"
        minH="36px"
        backgroundColor={themeBgContainer}
        borderRadius="50%"
        transition="0.3s"
        display="flex"
        alignItems="center"
        justifyContent="center"
        _groupHover={{
          backgroundColor: themeBgContainerHover,
        }}
      >
        {IconComponent && (
          <Box color={color}>
            <IconComponent size={size} />
          </Box>
        )}
        {badge && (
          <Box
            bgColor="bg.white"
            borderRadius="full"
            border="2px solid"
            borderColor="white"
            _dark={{
              borderColor: 'black',
            }}
            fontSize="10px"
            fontWeight="bold"
            right="-3px"
            bottom="-7px"
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
            lineHeight={1}
            whiteSpace="nowrap"
            css={{
              '& img': {
                maxHeight: '16px',
                maxWidth: '16px',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                display: 'block',
              },
            }}
          >
            {badge}
          </Box>
        )}
      </Box>
    </Flex>
  )
}
